module.exports = _.get;


//////////////////
// WEBPACK FOOTER
// external "_.get"
// module id = 41
// module chunks = business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings